import { useQuery } from "@tanstack/react-query"
import { routes, type ProductConfigVisuals } from "@nova-ai/shared"

import { apiFetch } from "../lib/api"
import { queryKeys } from "./query-keys"

/** The product page's Visuals view: one config's simples with their per-kind
 *  published / renderable / gap state in one store. A persisted-only read — it
 *  never renders; the per-cell Render action does. */
export function useProductConfigVisuals(configSku: string, store: string, enabled = true) {
  return useQuery({
    queryKey: queryKeys.productConfigVisuals(configSku, store),
    enabled: enabled && configSku.length > 0 && store.length > 0,
    queryFn: async () => {
      const result = await apiFetch<ProductConfigVisuals>(
        routes.products.visuals({ sku: configSku }),
        { query: { store } }
      )
      if (!result.ok) {
        throw new Error(result.error.message)
      }
      return result.value
    },
  })
}
